<ion-item>

  @if (showCheckbox) {
    <yu-checkbox
      style="width: auto"
      slot="start"
      [(value)]="item[ngModelCheckbox]"
    ></yu-checkbox>
  }

  <ion-thumbnail slot="start">
    <img [src]="item.foto || 'assets/img/empty-img/no_image.png'" alt=""/>
  </ion-thumbnail>

  <ion-label class="ion-text-wrap" (click)="editProduct.emit()">

    <div class="title">
      {{ item.nombre }}

      @if (!item.iva || !item.precio || (item.lacks_net_weight && !item.net_weight)) {
        <yu-icon name="warning" color="error"></yu-icon>
      }

      @if (item.cods_trazabilidad && item.cods_trazabilidad.length) {
        <yu-icon name="path" color="info"></yu-icon>
      }
    </div>

    @if (item.descripcion_compra) {
      <div class="description info">{{ item.descripcion_compra }}</div>
    }

    @if (!item.formato_multiplo) {
      <div class="description">
        {{ (quantity || 0) | number: '1.0-2' }} x {{ item.formato_ver }}
      </div>

    } @else {
      <div class="description">
        {{ ((quantity || 0) / item.formato_multiplo) | number: (item.formato_multiplo < 1 ? '1.0-0' : '1.0-2') }} x {{ item.formato_multiplo_label || 'pack' }}
      </div>
    }

    @if (item.precio_final_impuesto && quantity && data.should_see_price_by_provider_context && permissionsManager.checkPermission('precios', 'ver')) {
      <div class="description">
        Imp. alternativos: {{ (item.precio_final_impuesto * quantity) | currency: 'EUR':'symbol':'1.2-2':'es' }}
      </div>
    }

    @if (item.num_promo_multiplo) {
      <yu-helper color="info" icon="warning-circle">
        +{{ quantity ? quantity / item.num_promo_multiplo : 0 }} Gratis (Promoción {{ item.num_promo_multiplo }}+1)
      </yu-helper>
    }

    @if (item.desp_enviado) {
      <yu-helper color="error" icon="warning-circle">{{ item.diff_enviado }}</yu-helper>
    }

  </ion-label>

  <ion-note slot="end">

    <ng-content select="[content-note]"></ng-content>

    @if (item.precio && data.should_see_price_by_provider_context && permissionsManager.checkPermission('precios', 'ver')) {

      <p class="cost">
        <span [ngClass]="{'discount line': item.descuento}">
          {{ (quantity ? (quantity * item.precio) : 0) | currency: 'EUR': 'symbol': '1.2-2': 'es' }}
        </span>

        @if (item.descuento) {
          <span>
            {{ (quantity ? (quantity * (item.precio * (1 - item.descuento / 100))) : 0) | currency: 'EUR': 'symbol': '1.2-2': 'es' }}
          </span>
        }
      </p>

      @if (item.descuento) {
        <p class="discount">{{ item.descuento }}% Dto.</p>
      }

    }

  </ion-note>

</ion-item>
